<template>
  <div :class="isCollapsed ? 'flex justify-center' : ''">
    <div class="relative">
      <input
        type="text"
        :placeholder="isCollapsed ? '' : $t('Поиск')"
        class="input"
        :class="[isCollapsed ? 'short' : 'full']"
        disabled
      />
      <svg-icon
        name="sli-search"
        class="icon"
        :class="[isCollapsed ? 'icon--collapsed' : '']"
      />
      <!-- <div v-if="!isCollapsed" class="kbd-hint">
        <kbd>⌘</kbd>
        <kbd>K</kbd>
      </div> -->
    </div>
    <GlobalSearch v-model="showGlobalSearch" />
  </div>
</template>

<script>
import GlobalSearch from "@/features/global-search/ui/GlobalSearch.vue";

export default {
  name: "SearchBar",
  components: {
    GlobalSearch,
  },
  props: {
    isCollapsed: {
      type: Boolean,
    },
  },
  data() {
    return {
      showGlobalSearch: false,
    };
  },
  // mounted() {
  //   this._handleKeydown = (e) => {
  //     if ((e.metaKey || e.ctrlKey) && e.key === "k") {
  //       e.preventDefault();
  //       this.openGlobalSearch();
  //     }
  //   };
  //   document.addEventListener("keydown", this._handleKeydown);
  // },
  // beforeUnmount() {
  //   document.removeEventListener("keydown", this._handleKeydown);
  // },
  methods: {
    openGlobalSearch() {
      this.showGlobalSearch = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  @apply py-2 p-1 focus:outline-none cursor-not-allowed;
  @apply placeholder:font-medium;
  @apply rounded-md border border-border bg-card text-sm;
  height: 36px;
  padding: 0 8px;
  will-change: width;
  transition: width 0.3s ease;
  &::placeholder {
    @apply text-muted-foreground text-sm;
  }
}

.icon {
  @apply absolute pointer-events-none w-4 h-4 text-muted-foreground;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
}

.icon--collapsed {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.full {
  width: 100%;
  padding-left: 32px;
}
.short {
  width: 34px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Kbd shortcut hint 
.kbd-hint {
  @apply absolute pointer-events-none flex items-center gap-0.5;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
}

.kbd-hint kbd {
  @apply inline-flex items-center justify-center rounded border border-border bg-muted;
  @apply text-muted-foreground font-sans;
  font-size: 11px;
  min-width: 20px;
  height: 20px;
  padding: 0 4px;
  line-height: 1;
}*/
</style>
